import React from 'react';
import { Helmet } from 'react-helmet';

export default function PageTitle({ title }) {
  const fullTitle = title ? `${title} - ` : '';

  return (
    <Helmet>
      <title>{fullTitle}Expert360</title>
    </Helmet>
  );
}
